import { Box, Slider, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { formatHours, marks } from './HoursUtils'

type HoursSliderProps = {
  day: string
  disabled?: boolean
}

const HoursSlider = ({ day, disabled }: HoursSliderProps) => {
  const { control } = useFormContext()

  const handleOnChange = (value: number[], fieldProps: any) => {
    if (value[0] === 0 && value[1] === 24) {
      fieldProps.onChange({
        when: 'Always',
      })
    } else if (value[0] === 0 && value[1] === 0) {
      fieldProps.onChange({
        when: 'Never',
      })
    } else {
      fieldProps.onChange({
        when: 'Period',
        fromHour: value[0],
        fromMinute: 0,
        toHour: value[1],
        toMinute: 0,
      })
    }
  }

  return (
    <Controller
      control={control}
      name={`openingHours.${day}`}
      defaultValue={[0, 24]}
      render={({ field: { ...fieldProps } }) => {
        return (
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexGrow: 1,
              flexDirection: 'row',
              gap: '10px',
              justifyContent: 'space-around',
              alignItems: 'start',
            }}
          >
            <Typography
              sx={{
                textTransform: 'capitalize',
                flex: 1,
              }}
            >
              {day}
            </Typography>
            <Slider
              aria-label={`${day} hour slider`}
              min={0}
              max={24}
              marks={marks}
              step={1}
              onChange={(e: any) =>
                handleOnChange(e?.target?.value, fieldProps)
              }
              value={formatHours(fieldProps.value)}
              disabled={disabled}
              sx={{ width: '100%', flex: 5 }}
            />
          </Box>
        )
      }}
    />
  )
}

export default HoursSlider
